import { isProEnabled } from './isEnabled'

export default isProEnabled
